export const EC_INTEGRATION_TEST_URL = 'https://github.com/konflux-ci/build-definitions';
export const EC_INTEGRATION_TEST_REVISION = 'main';
export const EC_INTEGRATION_TEST_PATH = 'pipelines/enterprise-contract.yaml';
export const EC_INTEGRATION_TEST_KIND = 'enterprise-contract';
